<template>
  <div class="image-cropper d-flex justify-center">
      <img
          ref="image"
          :src="src"
          alt="Picture"
      />
  </div>
</template>

<script>
import Cropper from 'cropperjs/dist/cropper.esm.js'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'ImageCropper',
  props: {
    src: { type: String, required: true },
    width: { type: Number, default: 400 },
    height: { type: Number, default: 400 },
    resizeWidth: { type: Number, default: 400 },
    resizeHeight: { type: Number, default: 400 },
    aspectRatio: { type: Number, default: 1 },
    quality: { type: Number, default: 0.7 }
  },
  data() {
    return {
      cropper: null
    }
  },
  mounted() {
    this.cropper = new Cropper(this.$refs.image, {
      aspectRatio: this.aspectRatio,
      viewMode: 1,
      autoCropArea: 0.7,
      responsive: true,
      background: false,
      zoomable: false,
      scalable:false,
    });
  },
  beforeDestroy() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  },
  methods: {
    getDimensions(){
        const data = this.cropper?.getData()
        if(data){
            return data
        }
        return {x:0, y:0, width:1, height:1};
    },
    getAspectRatio(){
        return this.getDimentions().width / this.getDimentions().height;
    },
    getCroppedImage() {
      if (!this.cropper) return null;
      const base64 = this.cropper.getCroppedCanvas({
        width: this.outputWidth,
        height: this.outputHeight,

      }).toDataURL('image/jpeg', this.quality);
      return base64;
    },
    replace(url){
      this.cropper?.replace(url);
    },
    reset() {
      this.cropper?.reset();
    },
    replaceImage(newSrc) {
      this.cropper?.replace(newSrc);
    },
  }
}
</script>

<style scoped>
.image-cropper {
  width: 100%;
  height: auto;
}
.image-cropper img {
  width: 100%;
  /* display: block; */
  max-width:500px;
  max-height:500px;
}
img {
  display: block;
  max-width: 100%;
}
</style>
